"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataStorageManager_1 = __importDefault(require("../../data/DataStorageManager"));
const TextFormatter_1 = require("./TextFormatter");
class SheetBlock {
    // example : const SheetBlock = New SheetBlock(pages);
    constructor(pageNum) {
        this.rows = [];
        this.pageNum = pageNum;
        this.container = this.createContainer();
        this.addRows(8);
    }
    createContainer() {
        const container = document.createElement("div");
        container.className = "sheet-block";
        return container;
    }
    addRows(numRows) {
        for (let row = 1; row <= numRows; row++) {
            const lableContainer = this.createLableContainer(row);
            this.container.appendChild(lableContainer);
            const rowContainer = this.createRowContainer(row);
            this.container.appendChild(rowContainer);
            const lineContainer = this.createLineContainer();
            this.container.appendChild(lineContainer);
            this.rows.push(rowContainer);
        }
    }
    // Lable
    createLableContainer(row) {
        const lableContainer = document.createElement("div");
        lableContainer.className = "lable-container";
        this.addSectionLabel(lableContainer, row);
        return lableContainer;
    }
    addSectionLabel(rowContainer, row) {
        for (let col = 1; col <= 4; col++) {
            const labelDiv = document.createElement("div");
            labelDiv.id = `page${this.pageNum}-label-row${row}-col${col}`;
            labelDiv.className = "section-label";
            labelDiv.setAttribute("contentEditable", "true");
            labelDiv.setAttribute("data-store", "sheetblock");
            labelDiv.setAttribute("spellcheck", "false");
            labelDiv.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                }
            });
            labelDiv.textContent = "";
            DataStorageManager_1.default.updateData(labelDiv.id, { id: labelDiv.id, value: labelDiv.textContent });
            labelDiv.addEventListener("blur", () => {
                (0, TextFormatter_1.formatTextForLable)(labelDiv);
            });
            rowContainer.appendChild(labelDiv);
        }
    }
    // Chord
    createRowContainer(row) {
        const rowContainer = document.createElement("div");
        rowContainer.className = "chord-container";
        this.addEditableDivsToRow(rowContainer, row);
        return rowContainer;
    }
    addEditableDivsToRow(rowContainer, row) {
        for (let col = 1; col <= 8; col++) {
            const div = document.createElement("div");
            div.id = `page${this.pageNum}-row${row}-col${col}`;
            div.className = "chord";
            div.setAttribute("contentEditable", "true");
            div.setAttribute("data-store", "sheetblock");
            div.setAttribute("spellcheck", "false");
            div.style.whiteSpace = "nowrap";
            div.style.overflow = "hidden";
            div.style.textOverflow = "ellipsis";
            div.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                }
            });
            div.textContent = ""; // init()
            DataStorageManager_1.default.updateData(div.id, { id: div.id, value: div.textContent });
            div.addEventListener("blur", () => {
                (0, TextFormatter_1.formatTextForChord)(div);
            });
            rowContainer.appendChild(div);
        }
    }
    // Line
    createLineContainer() {
        const lineContainer = document.createElement("div");
        lineContainer.className = "line-container";
        this.addVerticalLines(lineContainer);
        return lineContainer;
    }
    addVerticalLines(lineContainer) {
        for (let i = 0; i < 5; i++) {
            const line = document.createElement("div");
            line.className = "vertical-line";
            lineContainer.appendChild(line);
        }
    }
    // for export
    getElement() {
        return this.container;
    }
}
exports.default = SheetBlock;
// ^^^^^^^^^ check! 2024/11/19 ^^^^^^^^
